export default function ConversaoBotao(_href, _janela = 0, _parceiro, _tipoAcao) {
    /*
     *  _tipoAcao: telefone, whatsapp, formulário, etc
        0: telefone
        1: whatsapp
        2: formulário
     */
    
    switch (_janela) {
        case 0:
            //alert(0);
            if (_parceiro == "google")
                window.gtag_report_conversion(0);

            if(_href != undefined && _href != null && _href != "")
                window.location.href = _href;
            break;
        case 1:
            //alert(1);
            if (_parceiro == "google")
                window.gtag_report_conversion(1);

            if(_href != undefined && _href != null && _href != "")
                window.open(_href, '_blank');
            break;
        case 2:
            //alert(2);
            if (_parceiro == "google")
                window.gtag_report_conversion(2);
            break;
    }
}